export function Footer() {
  return (
    <footer className="border-t border-rule bg-surface-sunken py-6">
      <div className="container mx-auto px-4 text-center text-meta text-ink-tertiary">
        &copy; {new Date().getFullYear()} QuarterMill. All rights reserved.
      </div>
    </footer>
  );
}
